import {NovoUsuario} from "../../auth/models/novo-usuario";

export class NovaEmpresa{
  tipoCliente: number;
  nome: string;
  cpf: string;
  razaoSocial: string;
  cnpj: string;
  email: string;
  plano: number;
  senha: string;
  confirmacaoSenha: string;
  tipoSaas: number;
}
